exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-paginated-table[data-v-7e15e860] {\r\n    width: 100%;\r\n    border-collapse: collapse;\n}\ninput[type='checkbox'][data-v-7e15e860] {\r\n    margin-left: 10px;\n}\r\n", ""]);

// exports
